{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Nova mensagem",
  "chat.scrollToBottom": "Scroll to bottom",
  "messagefeedback.thumbDown": "Má resposta",
  "messagefeedback.thumbUp": "Boa resposta",
  "promptfield.aiDisclaimer": "Responses are generated using AI, and may be inaccurate. Check before using.",
  "promptfield.aiUserGuidlines": "AI User Guidelines",
  "promptfield.attachments": "Attachments",
  "promptfield.insertButton": "Add",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Pronto para começar? Faça uma pergunta, partilhe uma ideia ou adicione uma tarefa.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Send",
  "promptfield.uploading": "Uploading",
  "responsestatus.loading": "A carregar",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Start recording",
  "voicebutton.stopListening": "Stop recording",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
